export interface IAuthorizeErrors {
  cardNumber?: string
  expirationDate?: string
  cvv?: string
  commonError?: string
}

export interface IAuthorizePaymentData {
  cardData: {
    cardNumber: string
    month: string
    year: string
    cardCode: string
  }
  authData: {
    clientKey: string
    apiLoginID: string
  }
}

export interface IAuthorizeOpaqueData {
  dataDescriptor: string
  dataValue: string
}

export interface IAuthorizeErrorMessage {
  code: string
  text: string
}

export interface IAuthorizeResponseMessages {
  resultCode: 'Error' | 'Ok'
  message: Array<IAuthorizeErrorMessage>
}

export interface IAuthorizePaymentResponse {
  opaqueData: IAuthorizeOpaqueData
  messages: IAuthorizeResponseMessages
}

export enum AuthorizeErrorCodes {
  I_WC_01 = 'I_WC_01',
  E_WC_01 = 'E_WC_01',
  E_WC_02 = 'E_WC_02',
  E_WC_03 = 'E_WC_03',
  E_WC_04 = 'E_WC_04',
  E_WC_05 = 'E_WC_05',
  E_WC_06 = 'E_WC_06',
  E_WC_07 = 'E_WC_07',
  E_WC_08 = 'E_WC_08',
  E_WC_09 = 'E_WC_09',
  E_WC_10 = 'E_WC_10',
  E_WC_11 = 'E_WC_11',
  E_WC_12 = 'E_WC_12',
  E_WC_13 = 'E_WC_13',
  E_WC_14 = 'E_WC_14',
  E_WC_15 = 'E_WC_15',
  E_WC_16 = 'E_WC_16',
  E_WC_17 = 'E_WC_17',
  E_WC_18 = 'E_WC_18',
  E_WC_19 = 'E_WC_19',
  E_WC_20 = 'E_WC_20',
  E_WC_21 = 'E_WC_21',
  E_WC_22 = 'E_WC_22',
  E_WC_23 = 'E_WC_23',
  E_WC_24 = 'E_WC_24',
  E_WC_25 = 'E_WC_25',
  E_WC_26 = 'E_WC_26',
  E_WC_27 = 'E_WC_27',
}
